import { render } from "./AdminCategory.vue?vue&type=template&id=1170a26c&scoped=true"
import script from "./AdminCategory.vue?vue&type=script&lang=js"
export * from "./AdminCategory.vue?vue&type=script&lang=js"

import "./AdminCategory.vue?vue&type=style&index=0&id=1170a26c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1170a26c"]])

export default __exports__